import { useDispatch } from 'react-redux';
import EditDialog from '../Common/EditDialog';
import useClientGroupUserForm from '../../hooks/useClientGroupUserForm';
import { addUserToGroup } from '../../redux/actions/clientGroups';

function AddUserToGroup({ setAddUserToGroup, id }) {
  const { userGroupFormSchema } = useClientGroupUserForm(id, true);

  const dispatch = useDispatch();

  const handleUpdate = (data: any) => {
    dispatch(addUserToGroup(data.UserId, id));
  };

  return (
    <EditDialog
      update={handleUpdate}
      onClose={() => setAddUserToGroup(false)}
      formSchema={userGroupFormSchema}
    />
  );
}

export default AddUserToGroup;
